import { baseUrl } from './routes';

export class DashboardRoutes {
  static get dashboard(): string {
    return `${baseUrl}/dashboard`;
  }

  static get home(): string {
    return `${baseUrl}/dashboard/home`;
  }

  static get admin(): string {
    return DashboardRoutes.home;
  }

  static get dashboardUnique(): string {
    return DashboardRoutes.home;
  }

  static get parentView(): string {
    return `parent`;
  }
}
